<template>
  <b-spinner v-if="loading" variant="orange" small class="mr-2" />
  <div v-else-if="machinePassword && machinePassword.password" v-b-modal.retrieve-password-modal class="machine-password cursor-pointer">
    <b-badge pill variant="dark" class="font-condensed font-weight-bold d-flex align-items-center justify-content-center">
      <b-icon icon="key" class="mr-1" />
      {{ 'password' | translate(labels, 'MachinePassword') }}: {{ machinePassword.password }}
    </b-badge>
    <b-icon icon="undo" class="ml-1 text-orange machine-password-refresh" />
  </div>
  <div v-else v-b-modal.retrieve-password-modal class="text-orange cursor-pointer">
    <b-icon icon="key" class="mr-1" />
    <span class="font-condensed"> {{ 'retrievePassword' | translate(labels, 'MachinePassword') }}</span>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  conceptName: ['MachinePassword'],
  data: () => ({
    loading: true
  }),
  emits: ['open-modal'],
  computed: {
    ...mapGetters({
      machinePassword: 'getMachinePassword'
    })
  },
  async mounted() {
    await this.$store.dispatch('fetchMachinePassword')
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/transitions.scss';
@import '../../../scss/colors.scss';
@import "../../../scss/grid";

.machine-password {
  display: flex;
  &:hover {
    .machine-password-refresh {
      transform: rotate(-90deg);
    }
  }
  &-refresh {
    transition: $transition-base;
  }
}
</style>
